/*
 * Copyright (C) 2019 Hunan Fantastic Network Technology Co., Ltd, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
import styles from './login.less';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { Alert, Button, Checkbox, Form, Icon, Input, Spin, message } from 'antd';
import { Translate, translate } from 'react-jhipster';

import Captcha from '../captcha/captcha';
import { getToken } from 'app/shared/util/token-utils';

import { IRootState } from 'app/shared/reducers';
import { login, login_cap, getCaptcha } from 'app/shared/reducers/authentication';
import Result from 'app/shared/components/result';
import { getPhoneNumber, getSmsCaptcha, getCodeCaptcha } from 'app/shared/common/captcha.reducer';

export interface ILoginProps extends StateProps, DispatchProps, RouteComponentProps<{}> {
  form: any;
}

export interface ILoginState {
  updateCaptcha: boolean;
  updateSmsCaptcha: boolean;
  captcha?: {
    captchaCode?: string;
    captchaBase64Str?: string;
  };
  phone?: number;
  userName?: string;
  code?: string;
  smsCaptchaCountdown: number;
}

const FormItem = Form.Item;

export class Login extends React.Component<ILoginProps, ILoginState> {
  private countdownTimer: number | null = null;
  constructor(props) {
    super(props);

    this.state = {
      updateCaptcha: false,
      updateSmsCaptcha: false,
      captcha: {
        captchaCode: '',
        captchaBase64Str: ''
      },
      phone: null,
      code: '',
      smsCaptchaCountdown: 0
    };
  }

  componentWillUnmount() {
    // 清除倒计时定时器
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  }

  handleLogin = (username, password, captcha, rememberMe = false) => {
    this.props.login_cap(username, password, captcha, rememberMe);
    const { token } = getToken();
    // 未登录成功，重新请求图形验证码
    if (!token) {
      this.handleCaptcha();
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { userName } = this.state;
        const { password, captcha, remember } = values;
        this.setState(
          (state, props) => ({
            updateCaptcha: false
          }),
          () => {
            this.handleLogin(userName, password, captcha, remember);
          }
        );
      }
    });
  };

  componentDidUpdate() {
    // if (!this.state.updateCaptcha) {
    //   this.setState(
    //     (state, props) => ({
    //       updateCaptcha: true
    //     }),
    //     () => {
    //       this.handleCaptcha();
    //     }
    //   );
    // }
    // if (!this.state.updateCaptcha) {
    //   this.handleCaptcha();
    // }
  }

  handleCaptcha = () => {
    const { phone } = this.state;
    const { code } = this.props.form.getFieldsValue();
    if (!phone || !code) {
      message.warning('请先输入用户名/手机号和短信验证码');
      return;
    }
    this.setState(
      {
        updateCaptcha: true
      },
      async () => {
        // this.props.getCaptcha();
        const res = await getCodeCaptcha(phone, code);
        const imageUrl = URL.createObjectURL(res.data);
        // console.log(res);
        if (res.status === 200) {
          this.setState({
            captcha: { captchaBase64Str: imageUrl }
          });
        }
      }
    );
  };

  handleSmsCaptcha = () => {
    const { userName } = this.props.form.getFieldsValue();
    if (!userName) {
      // 用户名为空时提示
      alert(translate('login.form.username.require'));
      return;
    }

    this.handlePhoneNumber(userName).then(() => {
      // 防止重复点击
      if (this.state.smsCaptchaCountdown > 0) return;

      this.setState(
        {
          updateSmsCaptcha: true,
          smsCaptchaCountdown: 60 // 60秒倒计时
        },
        async () => {
          // 传递phone参数获取短信验证码
          const res = await getSmsCaptcha(this.state.phone);
          if (res.status === 200) {
            this.setState({
              code: res.data.smsCode || '', // 假设接口返回短信验证码字段为smsCode
              updateSmsCaptcha: false
            });
          } else {
            // 失败后重置倒计时
            this.setState({
              smsCaptchaCountdown: 0,
              updateSmsCaptcha: false
            });
          }
        }
      );
    });

    this.countdownTimer = setInterval(() => {
      this.setState(prev => {
        if (prev.smsCaptchaCountdown <= 1) {
          clearInterval(this.countdownTimer!);
          return { smsCaptchaCountdown: 0 };
        }
        return { smsCaptchaCountdown: prev.smsCaptchaCountdown - 1 };
      });
    }, 1000);
  };

  handlePhoneNumber = async uorp => {
    const res = await getPhoneNumber(uorp);
    if (res.status === 200) {
      this.setState({
        phone: res.data.phone || null,
        userName: res.data.username || null
      });
    }
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { location, isAuthenticated, loading } = this.props;
    const { from } = location.state || { from: { pathname: '/', search: window.location.search } };
    const { updateCaptcha, smsCaptchaCountdown } = this.state;
    if (loading) {
      return (
        <div
          style={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            background: '#fff',
            top: 0,
            left: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Spin />
        </div>
      );
    }
    if (isAuthenticated) {
      return <Redirect to={from} />;
    } else {
      // if (!updateCaptcha) {
      //   this.handleCaptcha();
      // }
    }

    // 短信验证码按钮显示文本
    const smsCaptchaBtnText = smsCaptchaCountdown > 0 ? `${smsCaptchaCountdown}s后重新获取` : translate('login.form.code.get');

    return (
      <div className={styles.main}>
        <div className={styles.login}>
          <Form onSubmit={this.handleSubmit}>
            {this.props.loginError ? (
              <Alert message={translate('login.messages.error.authentication')} className={styles.alert} closable type="error" />
            ) : null}
            <FormItem>
              {getFieldDecorator('userName', {
                rules: [{ required: true, message: translate('login.form.username.require') }]
              })(
                <Input
                  size={'large'}
                  prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                  placeholder={translate('login.form.username.placeholder')}
                  className={styles.prefixIcon}
                  autoComplete={'off'}
                />
              )}
            </FormItem>
            <FormItem>
              {getFieldDecorator('password', {
                rules: [{ required: true, message: translate('login.form.username.require') }]
              })(
                <Input
                  size="large"
                  prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                  type="password"
                  placeholder={translate('login.form.password.placeholder')}
                  className={styles.prefixIcon}
                  autoComplete={'off'}
                />
              )}
            </FormItem>
            <FormItem>
              {getFieldDecorator('code', {
                rules: [{ required: true, message: translate('login.form.code.require') }]
              })(
                <div>
                  <div style={{ marginBottom: 16 }}>
                    <Input
                      size={'large'}
                      prefix={<Icon type="safety-certificate" style={{ color: 'rgba(0,0,0,.25)' }} />}
                      placeholder={translate('login.form.code.placeholder')}
                      className={styles.prefixIcon}
                      autoComplete={'off'}
                      addonAfter={
                        <Button type="link" onClick={this.handleSmsCaptcha} disabled={smsCaptchaCountdown > 0} style={{ padding: 0 }}>
                          {smsCaptchaBtnText}
                        </Button>
                      }
                      defaultValue=""
                    />
                  </div>
                </div>
              )}
            </FormItem>
            <FormItem>
              {getFieldDecorator('captcha', {
                rules: [{ required: true, message: translate('login.form.captcha.require') }]
              })(
                <div>
                  <div style={{ marginBottom: 16 }}>
                    <Input
                      size={'large'}
                      prefix={<Icon type="safety-certificate" style={{ color: 'rgba(0,0,0,.25)' }} />}
                      placeholder={translate('login.form.captcha.placeholder')}
                      className={styles.prefixIcon}
                      autoComplete={'off'}
                      addonAfter={
                        this.state.captcha.captchaBase64Str ? (
                          <Captcha src={this.state.captcha.captchaBase64Str} onClick={this.handleCaptcha} />
                        ) : (
                          <Button type="link" onClick={this.handleCaptcha} style={{ padding: 0 }}>
                            {translate('login.form.captcha.get')}
                          </Button>
                        )
                      }
                      defaultValue=""
                    />
                  </div>
                </div>
              )}
            </FormItem>
            <FormItem>
              {getFieldDecorator('remember', {
                valuePropName: 'checked',
                initialValue: true
              })(
                <Checkbox>
                  <Translate contentKey={'login.form.rememberme'} />
                </Checkbox>
              )}
              <Button type="primary" htmlType="submit" size={'large'} className={styles.submit}>
                <Translate contentKey={'login.form.button'} />
              </Button>
            </FormItem>
          </Form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ authentication }: IRootState) => ({
  isAuthenticated: authentication.isAuthenticated,
  loginError: authentication.loginError,
  showModal: authentication.showModalLogin,
  loading: authentication.loading,
  captcha: authentication.captcha
});

const mapDispatchToProps = { login_cap, getCaptcha };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

const WrappedNormalLoginForm = Form.create()(Login);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WrappedNormalLoginForm);
